import GrowthCenter from './modules/growth-center';

export default {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {},
  getters: {},
  // 嵌套模块，继承父模块的命名空间
  modules: {
    GrowthCenter,
  },
};



// WEBPACK FOOTER //
// ./src/store/App/index.js